export const siteConfig = {
  name: '五一吃瓜网',
  slogan: '每日吃瓜不打烊',
  description: '全国吃瓜群众聚集的爆料基地，网红黑料、明星秘闻、社会热点每日更新',
  domain: 'xsxwlkjh.cn',
};

export const navLinks = [
  { label: '首页', href: '/' },
  { label: '网红黑料', href: '/category/wanghong' },
  { label: '明星秘闻', href: '/category/mingxing' },
  { label: '社会热点', href: '/category/shehui' },
  { label: '关于我们', href: '/about' },
];

export const categories = [
  { slug: 'wanghong', name: '网红黑料', icon: 'ri-user-smile-line', description: '网红圈最新爆料，扒一扒你不知道的那些事' },
  { slug: 'mingxing', name: '明星秘闻', icon: 'ri-star-line', description: '明星八卦一手掌握，娱乐圈最新动向' },
  { slug: 'shehui', name: '社会热点', icon: 'ri-fire-line', description: '社会热点事件深度追踪，反转不断' },
  { slug: 'zonghe', name: '综合吃瓜', icon: 'ri-global-line', description: '各类吃瓜内容大杂烩，一网打尽' },
];

export const tags = [
  { slug: 'fanchezai', name: '翻车现场' },
  { slug: 'zhenxiang', name: '真相揭秘' },
  { slug: 'bagua', name: '八卦速递' },
  { slug: 'tuijian', name: '编辑推荐' },
  { slug: 'rewen', name: '热搜追踪' },
  { slug: 'shenba', name: '深度扒皮' },
  { slug: 'chigua', name: '前线吃瓜' },
  { slug: 'zhuanji', name: '独家爆料' },
];

export const articles = [
  {
    id: 1,
    slug: 'wanghong-zhang-san-fanche',
    title: '网红张三直播翻车现场！粉丝怒斥：这次真的太过分了',
    excerpt: '知名网红张三在昨晚的直播中因不当言论引发轩然大波，短短十分钟掉粉超过50万，评论区彻底沦陷...',
    content: `<p>昨晚8点，拥有超过800万粉丝的知名网红张三在例行直播中，因一段针对某合作品牌的不当言论，引发了一场前所未有的翻车事件。</p>
    <p>事情起因于张三在介绍一款护肤品时，突然话锋一转，表示"这个品牌给我的价格太低了，我都不好意思推荐给你们"。这番言论瞬间点燃了直播间观众的怒火。</p>
    <p>"我们是来看你分享好物的，不是来听你抱怨收入的！"一位粉丝在弹幕中愤怒地写道。紧接着，越来越多观众加入了声讨的行列。</p>
    <h2>十分钟掉粉50万</h2>
    <p>据第三方数据平台统计，从张三说出那句话开始，短短十分钟内其账号掉粉超过52万。更有意思的是，竞争对手李四的直播间在同一时段涌入了大量新观众。</p>
    <p>张三的经纪团队随后紧急叫停了直播，并于当晚11点发布了一份道歉声明。然而，这份被网友称为"模板化"的道歉并没有获得粉丝的原谅。</p>
    <h2>网友评论炸了</h2>
    <p>"这不是第一次了好吗？上次跟那个面膜品牌也是这样，人家给了六位数他还嫌少。""吃相太难看了，取关！""干得漂亮，终于不用看他那张脸了。"</p>
    <p>截至目前，张三的社交账号仍未更新，其团队也未作出进一步回应。据悉，已有三家合作品牌宣布暂停与张三的合作关系。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20streaming%20studio%20with%20dramatic%20red%20warm%20lighting%2C%20modern%20live%20streaming%20setup%20with%20ring%20light%2C%20dramatic%20atmosphere%2C%20editorial%20photography%20style%2C%20warm%20amber%20and%20crimson%20tones%2C%20cinematic%20mood%2C%20clean%20background%20with%20subtle%20texture&width=800&height=450&seq=article-wanghong-01&orientation=landscape',
    category: 'wanghong',
    tags: ['fanchezai', 'bagua'],
    author: '吃瓜前线',
    publishDate: '2026-06-28',
    readCount: 128500,
    commentCount: 3420,
    isHot: true,
    isNew: false,
  },
  {
    id: 2,
    slug: 'mingxing-li-mou-chugui',
    title: '某L姓顶流男星深夜密会神秘女子，酒店同住三天两夜',
    excerpt: '记者蹲守72小时拍到实锤画面！L姓男星与一名圈外女子在某五星级酒店共度三天两夜，全程亲密互动...',
    content: '<p>内容加载中...</p>',
    coverImage: 'https://readdy.ai/api/search-image?query=Luxury%20five-star%20hotel%20exterior%20at%20night%2C%20warm%20golden%20ambient%20lighting%2C%20elegant%20architecture%2C%20mysterious%20atmosphere%2C%20cinematic%20night%20photography%2C%20dark%20moody%20tones%20with%20warm%20highlights%2C%20paparrazi%20style%20vibe&width=800&height=450&seq=article-mingxing-01&orientation=landscape',
    category: 'mingxing',
    tags: ['bagua', 'rewen'],
    author: '娱乐侦查员',
    publishDate: '2026-06-27',
    readCount: 356200,
    commentCount: 12580,
    isHot: true,
    isNew: false,
  },
  {
    id: 3,
    slug: 'shehui-dasheng-fanzhuan',
    title: '某大厂裁员事件惊天反转！被裁员工手握录音证据曝光内幕',
    excerpt: '原本以为是一场普通的裁员，没想到背后藏着如此惊人的内幕。被裁员工晒出多段录音，直指管理层违规操作...',
    content: '<p>内容加载中...</p>',
    coverImage: 'https://readdy.ai/api/search-image?query=Modern%20corporate%20office%20building%20exterior%20at%20dusk%2C%20dramatic%20warm%20sunset%20lighting%2C%20glass%20skyscraper%2C%20moody%20atmosphere%2C%20editorial%20photography%2C%20professional%20setting%20with%20warm%20golden%20and%20deep%20shadow%20tones&width=800&height=450&seq=article-shehui-01&orientation=landscape',
    category: 'shehui',
    tags: ['zhenxiang', 'rewen'],
    author: '社会观察者',
    publishDate: '2026-06-26',
    readCount: 89200,
    commentCount: 4560,
    isHot: true,
    isNew: false,
  },
  {
    id: 4,
    slug: 'wanghong-meizhuang-fake',
    title: '美妆博主"纯天然"人设崩塌！医美诊所内部记录遭泄露',
    excerpt: '号称"从不动刀"的百万美妆博主，被曝曾多次光顾某知名医美机构。诊所前员工爆料其消费记录高达六位数...',
    content: '<p>内容加载中...</p>',
    coverImage: 'https://readdy.ai/api/search-image?query=Elegant%20beauty%20clinic%20interior%20with%20soft%20warm%20lighting%2C%20modern%20aesthetic%20medical%20setting%2C%20clean%20white%20and%20rose%20gold%20accents%2C%20professional%20atmosphere%2C%20editorial%20medical%20photography%2C%20subtle%20warm%20tones&width=800&height=450&seq=article-wanghong-02&orientation=landscape',
    category: 'wanghong',
    tags: ['shenba', 'zhenxiang'],
    author: '吃瓜前线',
    publishDate: '2026-06-25',
    readCount: 201300,
    commentCount: 8970,
    isHot: true,
    isNew: false,
  },
  {
    id: 5,
    slug: 'mingxing-jiemu-zhengzhi',
    title: '综艺节目录制现场爆发激烈争执！两位导师当场翻脸离场',
    excerpt: '某热门综艺录制现场爆发严重争执，两位导师因对选手评价产生分歧，当场摔话筒离场，节目录制被迫中断...',
    content: '<p>内容加载中...</p>',
    coverImage: 'https://readdy.ai/api/search-image?query=TV%20show%20recording%20studio%20set%20with%20dramatic%20stage%20lighting%2C%20red%20and%20gold%20warm%20tones%2C%20empty%20judges%20chairs%2C%20tension%20atmosphere%2C%20professional%20broadcast%20setting%2C%20cinematic%20mood&width=800&height=450&seq=article-mingxing-02&orientation=landscape',
    category: 'mingxing',
    tags: ['bagua', 'fanchezai'],
    author: '娱乐侦查员',
    publishDate: '2026-06-24',
    readCount: 178900,
    commentCount: 7230,
    isHot: false,
    isNew: true,
  },
  {
    id: 6,
    slug: 'shehui-shuiwu-zisha',
    title: '税务局最新通报：某头部主播补缴税款超两亿引发行业地震',
    excerpt: '税务部门最新通报显示，某头部带货主播被查实偷逃税款，已补缴税款及滞纳金合计超过2亿元...',
    content: '<p>内容加载中...</p>',
    coverImage: 'https://readdy.ai/api/search-image?query=Government%20building%20with%20Chinese%20national%20emblem%2C%20solemn%20atmosphere%2C%20warm%20golden%20hour%20lighting%2C%20official%20setting%2C%20professional%20architectural%20photography%2C%20deep%20red%20and%20gold%20color%20palette&width=800&height=450&seq=article-shehui-02&orientation=landscape',
    category: 'shehui',
    tags: ['zhenxiang', 'tuijian'],
    author: '社会观察者',
    publishDate: '2026-06-23',
    readCount: 451000,
    commentCount: 18900,
    isHot: true,
    isNew: false,
  },
  {
    id: 7,
    slug: 'zonghe-yule-quan-dizhen',
    title: '娱乐圈大地震！多位明星工作室连夜发布声明划清界限',
    excerpt: '一场由某导演引发的连锁反应正在娱乐圈蔓延。多位当红明星的工作室在深夜密集发布声明，引发全网猜测...',
    content: '<p>内容加载中...</p>',
    coverImage: 'https://readdy.ai/api/search-image?query=Dramatic%20night%20cityscape%20with%20bright%20neon%20lights%2C%20Chinese%20entertainment%20district%2C%20mysterious%20atmosphere%2C%20warm%20red%20and%20gold%20ambient%20lighting%2C%20cinematic%20photography%2C%20urban%20night%20mood&width=800&height=450&seq=article-zonghe-01&orientation=landscape',
    category: 'zonghe',
    tags: ['rewen', 'bagua'],
    author: '娱乐侦查员',
    publishDate: '2026-06-22',
    readCount: 532000,
    commentCount: 25600,
    isHot: true,
    isNew: false,
  },
  {
    id: 8,
    slug: 'wanghong-daihuo-jiahuo',
    title: '知名带货主播被曝卖假货！消费者晒出鉴定报告实锤',
    excerpt: '又一位头部主播陷入假货风波！多名消费者联合发声，晒出第三方鉴定报告，指控其直播间销售的某名牌包包为假货...',
    content: '<p>内容加载中...</p>',
    coverImage: 'https://readdy.ai/api/search-image?query=Luxury%20handbag%20with%20magnifying%20glass%20detail%2C%20authentication%20scene%2C%20warm%20studio%20lighting%2C%20product%20investigation%20atmosphere%2C%20editorial%20photography%2C%20cream%20background%20with%20subtle%20warm%20tones&width=800&height=450&seq=article-wanghong-03&orientation=landscape',
    category: 'wanghong',
    tags: ['zhenxiang', 'fanchezai'],
    author: '吃瓜前线',
    publishDate: '2026-06-21',
    readCount: 289000,
    commentCount: 14300,
    isHot: false,
    isNew: true,
  },
  {
    id: 9,
    slug: 'mingxing-xinju-baohong',
    title: '新剧开播三天播放量破十亿！这对CP让全网嗑到上头',
    excerpt: '一部小成本网剧意外爆红，男女主角的化学反应让观众欲罢不能。开播仅三天，全网播放量突破十亿，CP超话冲上热搜第一...',
    content: '<p>内容加载中...</p>',
    coverImage: 'https://readdy.ai/api/search-image?query=Romantic%20Chinese%20period%20drama%20scene%20with%20warm%20lantern%20lighting%2C%20elegant%20traditional%20costumes%2C%20soft%20golden%20glow%2C%20cinematic%20atmosphere%2C%20beautiful%20composition%2C%20warm%20amber%20and%20rose%20tones&width=800&height=450&seq=article-mingxing-03&orientation=landscape',
    category: 'mingxing',
    tags: ['tuijian', 'rewen'],
    author: '娱乐侦查员',
    publishDate: '2026-06-20',
    readCount: 167800,
    commentCount: 8920,
    isHot: false,
    isNew: false,
  },
  {
    id: 10,
    slug: 'shehui-jiapei-qishu',
    title: '某地学区房政策突然调整，买了房的家长集体维权',
    excerpt: '一地学区房划分政策突然调整，原本承诺的对口名校被替换。数百名高价购房的家长聚集维权，要求政府给出合理解释...',
    content: '<p>内容加载中...</p>',
    coverImage: 'https://readdy.ai/api/search-image?query=Modern%20residential%20community%20exterior%20with%20warm%20sunset%20lighting%2C%20Chinese%20urban%20neighborhood%2C%20apartment%20buildings%2C%20warm%20golden%20hour%20glow%2C%20editorial%20photography%2C%20atmospheric%20urban%20scene&width=800&height=450&seq=article-shehui-03&orientation=landscape',
    category: 'shehui',
    tags: ['rewen', 'tuijian'],
    author: '社会观察者',
    publishDate: '2026-06-19',
    readCount: 98700,
    commentCount: 5670,
    isHot: false,
    isNew: false,
  },
  {
    id: 11,
    slug: 'zonghe-chigua-heji',
    title: '本周吃瓜合集：从恋爱官宣到互撕大战，信息量爆炸的一周',
    excerpt: '这周的瓜实在太多了！三对明星官宣恋情、两场网红互撕、一个品牌翻车，每一条都让人惊掉下巴，快来看看你错过了什么...',
    content: '<p>内容加载中...</p>',
    coverImage: 'https://readdy.ai/api/search-image?query=Colorful%20collage%20of%20Chinese%20entertainment%20news%2C%20vibrant%20warm%20red%20and%20gold%20tones%2C%20magazine%20cover%20style%2C%20dramatic%20composition%2C%20editorial%20design%20aesthetic%2C%20clean%20background%20with%20bold%20accents&width=800&height=450&seq=article-zonghe-02&orientation=landscape',
    category: 'zonghe',
    tags: ['bagua', 'tuijian'],
    author: '吃瓜前线',
    publishDate: '2026-06-18',
    readCount: 213400,
    commentCount: 9870,
    isHot: false,
    isNew: false,
  },
  {
    id: 12,
    slug: 'wanghong-zhibo-jianbing',
    title: '两大人气主播隔空互怼！从暗讽到点名道姓只用了一天',
    excerpt: '原本井水不犯河水的两位头部主播突然在各自的直播间互相内涵，一天之内从暗讽发展到点名道姓互撕...',
    content: '<p>内容加载中...</p>',
    coverImage: 'https://readdy.ai/api/search-image?query=Split%20screen%20streaming%20studio%20with%20dramatic%20red%20versus%20blue%20warm%20lighting%2C%20competition%20theme%2C%20modern%20live%20streaming%20setup%2C%20tense%20atmosphere%2C%20cinematic%20mood%2C%20dual%20tone%20composition&width=800&height=450&seq=article-wanghong-04&orientation=landscape',
    category: 'wanghong',
    tags: ['fanchezai', 'bagua'],
    author: '吃瓜前线',
    publishDate: '2026-06-17',
    readCount: 345600,
    commentCount: 16780,
    isHot: true,
    isNew: false,
  },
];

export const brandInfo = {
  name: '五一吃瓜网',
  founded: '2020年',
  intro: '五一吃瓜网成立于2020年，是国内领先的娱乐八卦内容聚合平台。我们致力于为全国吃瓜群众提供最新、最全、最真实的娱乐爆料和热点追踪内容。',
  features: [
    { title: '每日更新', description: '365天不间断更新，让吃瓜群众每天都有新鲜瓜可吃' },
    { title: '一手爆料', description: '拥有专业的前线吃瓜团队，第一时间获取最新消息' },
    { title: '深度扒皮', description: '不只是表面吃瓜，我们深挖每一个事件背后的真相' },
    { title: '多元视角', description: '多角度呈现事件全貌，让吃瓜群众全面了解真相' },
  ],
};

export const reviews = [
  {
    name: '吃瓜达人小王',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20man%20portrait%2C%20casual%20style%2C%20warm%20lighting%2C%20friendly%20expression%2C%20clean%20cream%20background%2C%20professional%20headshot&width=100&height=100&seq=review-avatar-01&orientation=squarish',
    content: '关注五一吃瓜网三年了，每天上班第一件事就是打开看看今天有什么新瓜。内容质量一直很高，从来不瞎编乱造，吃瓜吃得放心！',
    rating: 5,
  },
  {
    name: '娱乐八卦爱好者',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20woman%20portrait%2C%20modern%20style%2C%20warm%20lighting%2C%20smiling%20expression%2C%20clean%20cream%20background%2C%20professional%20headshot&width=100&height=100&seq=review-avatar-02&orientation=squarish',
    content: '比微博热搜快多了！很多瓜都是在五一吃瓜网先看到的，然后过好几天才上热搜。更新速度真的没话说，强烈推荐！',
    rating: 5,
  },
  {
    name: '资深吃瓜群众',
    avatar: 'https://readdy.ai/api/search-image?query=Middle%20aged%20Chinese%20person%20portrait%2C%20casual%20elegant%20style%2C%20warm%20lighting%2C%20confident%20expression%2C%20clean%20cream%20background%2C%20professional%20headshot&width=100&height=100&seq=review-avatar-03&orientation=squarish',
    content: '作为吃了十年瓜的老群众，可以负责任地说五一吃瓜网是目前国内最靠谱的吃瓜平台。深度扒皮系列每期都追，从不让人失望！',
    rating: 5,
  },
];

export const contactInfo = {
  email: 'contact@xsxwlkjh.cn',
  wechat: 'xsxwlkjh',
  weibo: '@五一吃瓜网',
  address: '北京市朝阳区互联网产业园区',
};
